import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Çıkış Yap',
  openMenu: 'Menüyü Aç',
  closeMenu: 'Menüyü Kapat',
  author: 'Paylaşan',
  'add-review': 'Mmm! Yemek hikayeni paylaş!',
  'add-review-to-food': '{{food}} deneyimini bizimle paylaş',
  'media.video': 'Video',
  'media.image': 'Resim',
  food: {
    title: 'Yemek',
    gourmets: '{{food}} Tutkunları',
    bestPlaces: '{{food}} için En İyi Mekanlar',
    gourmetsSectionDescription:
      "{{food}} konusunda uzmanları keşfedin! Yemek tutkunlarımız, deneme sayılarına ve değerlendirmelerine göre sıralanır.",
    bestPlacesSectionDescription:
      'Harika {{food}} mi arıyorsunuz? Bu mekanlar, işin uzmanları tarafından değerlendirildi!',
    beTheFirstReviewer: {
      title: '{{foodName}} için İlk Değerlendirmeyi Yapın!',
      description: 'Sizin tat deneyiminiz önemli! Değerlendirmenizi paylaşın ve diğer yemek tutkunlarının bu yemeği keşfetmesine yardımcı olun.',
      button: 'İlk Değerlendirmeyi Yaz'
    }
  },
  common: {
    next: 'İleri',
    previous: 'Geri',
    save: 'Kaydet',
    noMoreReviews: 'Değerlendirme bulunamadı',
    error: {
      default: 'Ups! Bir şeyler yanlış gitti.',
      fetchFailed: 'Veri getirilemedi',
      rateLimitExceeded: 'Çok fazla istek. Lütfen biraz bekleyip tekrar deneyin.',
    },
    search: 'Ara',
    back: 'Geri',
    cancel: 'İptal',
    loading: 'Yükleniyor...',
    delete: 'Sil',
    create: 'Oluştur',
    open: 'Açık',
    closed: 'Kapalı',
    country: 'Ülke',
    reviews: 'Değerlendirmeler',
    reviews_count: '{{count}} kişi denemiş',
    showMore: 'Daha Fazla',
    showLess: 'Daha Az',
    uploadImage: 'Resim Yükle',
    uploadMedia: 'Medya Yükle',
    deleteMedia: 'Medyayı Sil',
    uploadedMedia: 'Yüklenen Medya',
    sort: 'Sırala',
    loadMore: 'Daha Fazla',
    backToHome: 'Ana Sayfaya Dön',
    actions: {
      share: {
        label: 'Paylaş',
        copied: 'Bağlantı panoya kopyalandı',
        copyFailed: 'Bağlantı kopyalanamadı',
      },
    },
    exploreMore: 'Daha Fazla Keşfet',
    discoverExperiences: 'Yeni lezzet deneyimleri keşfet',
    reachedEndOfContent: 'İçeriğin sonuna geldiniz',
    comingSoon: 'Çok Yakında',
    notNow: 'Şimdi Değil',
    close: 'Kapat',
    saveChanges: 'Değişiklikleri Kaydet',
    food: 'yemek'
  },
  localeCurrency: 'Yerel Para Birimi',
  statuses: {
    active: 'Aktif',
    pending: 'Beklemede',
    rejected: 'Reddedildi',
  },
  notifications: {
    title: 'Bildirimler',
    pageTitle: 'Bildirimler',
    pageDescription: 'Bildirimlerinizi görüntüleyin ve yönetin',
    markAllAsRead: 'Hepsini oku'
  },
  seo: {
    keywords: {
      food: 'yemek',
      cuisine: 'mutfak',
      reviews: 'yorumlar',
      rating: 'puan',
      restaurants: 'restoranlar',
      dining: 'yemek yeme',
    },
    food: {
      title: '{{foodName}} İncelemesi',
      description:
        "En iyi {{foodName}} yiyebileceğiniz mekanları keşfedin. BiteCritic'te dürüst yorumlar okuyun ve yakınınızdaki en lezzetli {{foodName}} nerede bulunur öğrenin.",
      defaultDescription:
        '{{foodName}} keşfedin - yorumlar, puanlar ve yakınınızda en iyi {{foodName}} nerede bulunur.',
    },
    place: {
      defaultDescription:
        '{{placeName}} keşfedin - yorumlar, puanlar ve bu mekandaki popüler yemekler.',
      cityDescription:
        '{{cityName}} şehrindeki {{placeName}} keşfedin - yorumlar, puanlar ve bu mekandaki popüler yemekler.',
    },
    review: {
      defaultDescription:
        '{{username}}, {{placeName}} mekanındaki {{foodName}} için değerlendirme yaptı. Puan: {{rating}}/{{maxRating}}',
      foodTitle: '{{placeName}} - {{foodName}} Değerlendirmesi - {{rating}}/10',
      placeTitle: '{{placeName}} Değerlendirmesi - {{rating}}/10',
      metaDescription:
        "{{username}}'in {{placeName}} mekanındaki {{foodName}} için detaylı değerlendirmesini okuyun. Puan: {{rating}}/10. Bu {{type}}'ı özel yapan şeyi keşfedin.",
      authorTitle:
        "{{username}}'in {{placeName}} mekanındaki {{foodName}} Değerlendirmesi",
      ratingScale: 'Değerlendirme ölçeği: 0-10',
      reviewedType: {
        food: 'Yemek',
        restaurant: 'Restoran',
        product: 'Ürün',
      },
    },
    user: {
      defaultDescription:
        "{{username}}'in yemek yolculuğunu keşfet - yorumlar, favori yemekler ve lezzet maceraları.",
    },
    category: {
      defaultDescription:
        '{{categoryName}} yemeklerini keşfet - en iyi yemekleri, yorumları ve yakınında nerede bulabileceğini öğren.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle: 'BiteCritic - Yemek Deneyimlerini Keşfet ve Paylaş',
      defaultDescription:
        'Dünya çapındaki yemek severlerle birlikte harika mutfak deneyimlerini keşfet ve paylaş. Yakınındaki yemekler hakkında gerçek yorumlar, puanlamalar ve fotoğraflar bul.',
      defaultKeywords:
        'yemek, restoranlar, incelemeler, yemek, mutfak, yemek eleştirmenleri',
    },
  },
  drink: 'İçecek',
  place: 'Mekan',
  'where-did-you-eat': 'Nerede yedin?',
  'what-did-you-eat': 'Ne yedin?',
  category: 'Kategori',
  name: 'İsim',
  rating: 'Puanınız',
  welcome_modal: {
    title: "BiteCritic'e Hoş Geldiniz!",
    subtitle: 'Bir Sonraki Favori Lokmanızı Keşfedin',
    description:
      'BiteCritic, deneyimlerini paylaşan ve denedikleri yemekleri değerlendiren yemek tutkunlarının topluluğudur.',
    features: {
      title: "BiteCritic ile yapabilecekleriniz:",
      rate: 'Sadece restoranları değil, yemekleri de puanlayın',
      discover: 'Gerçek değerlendirmelere dayalı yeni yemekler keşfedin',
      connect: 'Diğer yemek tutkunlarıyla bağlantı kurun',
      track: 'Denemek istediğiniz yemekleri takip edin',
    },
    not_now: 'Şimdi Değil',
    join_now: 'Şimdi Katıl',
  },
  review: {
    label: 'Yorumunuz',
    writingIn: 'Bu yorumu şu dilde yazıyorum',
    success: 'Hikayeniz yayında!',
    error: 'Hikayenizi paylaşırken bir hata oluştu',
    foodReviewTitle:
      '{{placeName}}, {{city}} mekanındaki {{foodName}} için {{username}} yorumu',
    drinkReviewTitle:
      '{{placeName}}, {{city}} mekanındaki {{drinkName}} için {{username}} yorumu',
  },
  previous: 'Geri',
  next: 'İleri',
  'submit-review': 'Hikayeni Paylaş',
  cancel: 'Vazgeç',
  type: 'Ne Tür',
  'add-food-review': 'Ne yedin?',
  'select-food': 'Yemeğini seç',
  cost: 'Ne Kadardı?',
  'rating-explanation': '1 (Kötü) - 10 (Harika)',
  'write-your-review': 'Yemekle ilgili deneyiminizi puanlayın. Mekan hakkında değil. Nasıl tadı vardı? Hangi aromalar var? Hangi lezzetler var? Hangi kısımları beğendiniz? Hangi kısımları beğenmediniz?',
  'visited-at': 'Ne zaman gittin?',
  reviews: {
    noReviews: 'Değerlendirme bulunamadı',
    readFull: 'Tüm hikayeyi oku',
    showTranslation: 'Çeviriyi göster',
    showOriginal: 'Orijinali göster',
    translatedFrom: '{{language}} dilinden çevrildi',
    filters: {
      title: 'Filtreler',
      apply: 'Filtreleri Uygula',
      rating: 'Puan',
      cost: 'Fiyat',
      startDate: 'Başlangıç',
      endDate: 'Bitiş',
      location: 'Konum',
      radius: 'Arama Yarıçapı (km)',
      sort: {
        label: 'Sıralama',
        newest: 'En Yeni',
        oldest: 'En Eski',
        mostLiked: 'En Yüksek Puanlı',
        leastLiked: 'En Düşük Puanlı',
        mostExpensive: 'En Pahalı',
        cheapest: 'En Ucuz',
      },
      sortOrder: {
        asc: 'artan',
        desc: 'azalan',
      },
      sortBy: {
        createdAt: 'Tarih',
        likeCount: 'Beğeni',
        cost: 'Fiyat',
      },
      active: {
        rating: 'Min Puan: {{value}}',
        startDate: 'Başlangıç: {{date}}',
        endDate: 'Bitiş: {{date}}',
        cost: 'Min Fiyat: {{value}}',
        radius: '{{value}}km içinde',
      },
    },
  },
  validation: {
    'place-required': 'Oops! Önce bir mekan seç',
    'category-required': 'Bir kategori seç!',
    'review-min-length':
      'Biraz daha detay verebilir misin? (en az 80 karakter)',
    'rating-required': 'Puanlamayı unutma!',
    'cost-positive': 'Fiyat sıfırdan büyük olmalı',
    'visited-at-required': 'Ne zaman gittin?',
    'type-required': 'Yemek mi içecek mi?',
    'food-required': 'Ne yedin?',
    'drink-required': 'Ne içtin?',
    'country-required': 'Nerelisin?',
    required: 'Bu alan zorunludur',
  },
  auth: {
    welcomeBack: 'Merhaba! 👋',
    loginToContinue: 'Devam etmek için giriş yap',
    continueWithGoogle: 'Google ile devam et',
    continueWithApple: 'Apple ile devam et',
    logout: 'Sonra Görüşürüz!',
    login: 'Giriş Yap',
    signup: 'Kayıt Ol',
    signupToContinue: 'Gurme topluluğumuza katıl',
    joinCommunity: 'Yemek Topluluğumuza Katıl',
    required: 'Hadi Başlayalım!',
    actionRequiresAuth: 'Oops! Bunun için hızlı giriş yapmanız gerekiyor',
    alreadyLoggedIn: 'Zaten giriş yapmışsınız!',
    goToProfile: 'Profiline Git',
    continueToFeed: 'Akışa Devam Et',
    alreadyHaveAccount: 'Zaten hesabın var mı?',
    benefits: {
      title: 'Kaçırdıklarına bak:',
      follow: 'Favori yemeklerini takip et',
      review: 'Yemek maceralarını paylaş',
      save: 'Mekanları daha sonrası için kaydet',
      community: 'Diğer yemek severlerle tanış',
      personalized: 'Sana özel yemek önerileri al',
    },
    cta: {
      login: 'Haydi!',
      cancel: 'Belki Sonra',
    },
    actions: {
      followFood: 'Bu lezzetli yemeği takip etmek için hızlı giriş yap!',
      unfollowFood: 'Takibi bırakmak için giriş yap',
    },
    joinNow: 'Şimdi Katıl!',
  },
  profile: {
    follow: 'Takip Et',
    unfollow: 'Takibi Bırak',
    followers: 'Takipçiler',
    following: 'Takip Edilen',
    avatar: 'Profil Fotoğrafın',
    change_avatar: 'Fotoğrafı Değiştir',
    upload_avatar: 'Fotoğraf Yükle',
    title: 'Profilin',
    view: 'Profili Görüntüle',
    username: 'Kullanıcı Adı',
    email: 'E-posta',
    success: 'Harika görünüyor!',
    error: 'Oops, bir şeyler yanlış gitti',
    save: 'Kaydet',
    firstName: 'Ad',
    lastName: 'Soyad',
    birthDate: 'Doğum Tarihi',
    country: 'Ülke',
    bio: 'Hakkında',
    noAccount: 'Henüz hesabın yok mu?',
    bioPlaceholder: 'Bize yemek maceralarından bahset...',
    selectCountry: 'Ülkeni Seç',
    deleteAccount: {
      button: 'Hesabı Sil',
      title: 'Hesabını Sil',
      warning:
        'Uyarı: Bu işlem geri alınamaz. Tüm verileriniz, incelemeleriniz ve tercihleriniz kalıcı olarak silinecektir.',
      confirm: 'Hesabımı Sil',
      error: 'Hesap silinemedi. Lütfen daha sonra tekrar deneyin.',
    },
  },
  errors: {
    invalidFileType:
      'Geçersiz dosya türü. Lütfen sadece JPG, PNG, WebP, HEIC veya HEIF resimlerini yükleyin.',
    fileTooLarge: 'Dosya çok büyük. Maksimum boyut {{size}}.',
    tooManyFiles: 'Çok fazla dosya. İzin verilen maksimum sayı {{max}}.',
  },
  onboarding: {
    welcome: "BiteCritic'e Hoş Geldin!",
    setup_profile: 'Profilini oluşturalım',
    username: 'Kullanıcı Adı',
    username_required: 'Kullanıcı adı gerekli',
    username_min_length: 'Kullanıcı adı en az 3 karakter olmalı',
    username_pattern: 'Sadece harf, rakam ve alt çizgi kullanabilirsin',
    username_taken: 'Bu kullanıcı adı zaten kullanımda',
    username_available: 'Kullanıcı adı uygun!',
    username_requirements:
      'Kullanıcı adı en az 3 karakter olmalı ve sadece harf, rakam ve alt çizgi içerebilir',
    checking_username: 'Kullanıcı adı kontrol ediliyor...',
    first_name: 'Ad',
    first_name_required: 'Ad gerekli',
    first_name_min_length: 'Ad en az 2 karakter olmalı',
    first_name_max_length: 'Ad en fazla 20 karakter olabilir',
    last_name: 'Soyad',
    last_name_required: 'Soyad gerekli',
    last_name_min_length: 'Soyad en az 2 karakter olmalı',
    last_name_max_length: 'Soyad en fazla 20 karakter olabilir',
    birth_date: 'Doğum Tarihi',
    birth_date_required: 'Doğum tarihi gerekli',
    country: 'Ülke',
    complete_profile: 'Profili Tamamla',
    success: 'Profil başarıyla güncellendi!',
    error: 'Profil güncellenirken bir hata oluştu',
  },
  language: {
    select: 'Dil Seçin',
    select_country: 'Ülke Seçin',
    select_language: 'Dil Seçin',
    current: 'Mevcut Dil',
  },
  categories: {
    title: 'Kategoriler',
    meta: {
      title: 'Yemek Kategorileri - Lezzet Dünyasını Keşfet',
      description:
        'Çeşitli yemek kategorilerimizi keşfedin ve dünyanın dört bir yanından lezzetleri keşfedin. Yorumları, puanlamaları ve nerede tadını çıkarabileceğinizi bulun.',
      categoryTitle: 'Yemek Kategorisi',
      categoryDescription:
        '{{category}} keşfet - Bu kategoride yemek severlerin yorumları ve puanlamalarıyla {{count}} lezzetli yemeği keşfet.',
      keywords: 'yemek kategorileri, mutfak türleri, lezzet keşfi, yemek keşfi',
      loading: 'Kategori Yükleniyor',
      defaultDescription:
        'Çeşitli yemek kategorilerimizi keşfedin ve bir sonraki lezzet maceranızı bulun.',
    },
  },
  home: 'Ana Sayfa',
  places: {
    radius: 'Arama yarıçapı (km)',
    noPlacesFound: 'Henüz burada bir şey yok',
    tryAdjustingFilters: 'Daha fazla seçenek görmek için bir yer aramayı veya filtreleri ayarlamayı deneyin.',
    locationPermission: {
      title: 'Nereyi keşfetmek istersiniz?',
      description: 'Yakınınızdaki harika mekanları bulmak için konumu etkinleştirin veya belirli bir yer arayın.',
      allow: 'Konumumu kullan'
    },
    whereDidYouEat: 'Bunu nerede yedin?',
    searchByLocation: 'Nereye gitmek istiyorsun?',
    selectPlace: 'Bir yer ara...',
    yourLocation: 'Konumunuz',
    searchOrUseLocation: 'Başlamak için bir yer arayın veya konumunuzu kullanın.',
    locationStatus: {
      detecting: 'Konumunuz belirleniyor...',
      denied: 'Konum erişimi reddedildi',
      unavailable: 'Konum kullanılamıyor',
      found: 'Konum bulundu!'
    },
    sort: {
      title: 'Sıralama ölçütü',
      ratingDesc: 'En yüksek puanlı', 
      ratingAsc: 'En düşük puanlı',
      distanceAsc: 'En yakın önce',
      distanceDesc: 'En uzak önce',
      nameAsc: 'İsim (A-Z)',
      nameDesc: 'İsim (Z-A)',
      reviewCountDesc: 'En çok değerlendirilen',
      reviewCountAsc: 'En az değerlendirilen',
      newestFirst: 'En yeniler önce',
      oldestFirst: 'En eskiler önce'
    },
    period: {
      title: 'Zaman aralığı',
      ALL_TIME: 'Tüm zamanlar',
      LAST_WEEK: 'Geçen hafta',
      LAST_MONTH: 'Geçen ay',
      LAST_YEAR: 'Geçen yıl'
    },
    meta: {
      title: 'Yakınızdaki restoranları keşfedin',
      description: 'Bölgenizdeki en iyi restoranları bulun ve keşfedin. Değerlendirmeleri okuyun, fotoğrafları görün ve yeni yemek deneyimleri keşfedin.',
      titleWithPlace: '{{place}} yakınındaki en iyi mekanlar',
      descriptionWithPlace: '{{place}} yakınında {{radius}} km içindeki en iyi restoranları ve yemek mekanlarını keşfedin. Değerlendirmeleri okuyun, puanları görün ve bir sonraki favori yeme yerinizi bulun.'
    },
    navigation: {
      title: 'Mekanlar',
    },
    detail: {
      error: 'Oops! Bu mekanı bulamadık. Tekrar deneyin?',
      sections: {
        popularFoods: {
          title: '{{place}} mekanında en çok sevilenler',
          description:
            'Bu yemekler {{place}} mekanında yemek sever topluluğumuz tarafından en çok beğenilen yemeklerdir. Puanlara ve değerlendirme sayısına göre sıralanmıştır.',
          titleWithCity: '{{city}} şehrindeki {{place}} mekanında en çok sevilenler',
          descriptionWithCity:
            'Bu yemekler {{city}} şehrindeki {{place}} mekanında yemek sever topluluğumuz tarafından en çok beğenilen yemeklerdir. Puanlara ve değerlendirme sayısına göre sıralanmıştır.',
        },
        gourmets: {
          title: '{{place}} için en iyi yemek severler',
          description:
            '{{place}} mekanını en iyi bilen yemek severleri keşfedin. Değerlendirme sayılarına ve puanlarına göre sıralanmışlardır.',
          titleWithCity: '{{city}} şehrindeki {{place}} için en iyi yemek severler',
          descriptionWithCity:
            '{{city}} şehrindeki {{place}} mekanını en iyi bilen yemek severleri keşfedin. Değerlendirme sayılarına ve puanlarına göre sıralanmışlardır.',
        },
        reviews: {
          title: '{{place}} için değerlendirmeler',
          titleWithCity: '{{city}} şehrindeki {{place}} için değerlendirmeler',
        },
      },
    },
    emptyState: {
      title: 'Mekan bulunamadı',
      description: '{{username}} henüz hiçbir mekanı değerlendirmemiş.'
    },
    userMapTitle: '{{username}} kullanıcısının Yemek Haritası',
    reviewsDrawer: {
      title: '{{placeName}} için değerlendirmeler',
      noReviews: 'Bu mekan için henüz değerlendirme yok.',
      viewMore: 'Tüm değerlendirmeleri gör',
      addReview: 'Değerlendirme ekle'
    },
    viewAllVisited: '{{username}} tarafından ziyaret edilmiş ve değerlendirilmiş tüm mekanlar'
  },
  settings: {
    title: 'Ayarlar',
  },
  'review-not-found': 'İnceleme bulunamadı',
  'go-back': 'Geri dön',
  actions: {
    share: 'Paylaş',
  },
  users: {
    navigation: {
      title: 'Gurme Topluluğu',
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: '{{username}} Kullanıcısının Son Ziyaret Ettiği Mekanlar',
          description: '{{username}} kullanıcısının deneyimlerini paylaştığı mekanlar',
        },
        likedFoods: {
          title: '{{username}} Kullanıcısının Favori Lezzetleri',
          description: '{{username}} kullanıcısının deneyip değerlendirdiği yemekler',
        }
      },
    },
    map: {
      viewMap: 'Yemek Haritasını Görüntüle',
      seoTitle: '{{username}} kullanıcısının Yemek Haritası',
      seoDescription: '{{username}} kullanıcısının ziyaret ettiği ve değerlendirdiği yerleri Yemek Haritası üzerinde keşfedin.'
    },
    title: 'Kişileri Bul',
    searchPlaceholder: 'İsim veya kullanıcı adına göre ara',
    noResults: 'Kullanıcı bulunamadı',
    seoTitle: 'Yemek Eleştirmenleri ve Yorumcuları',
    seoDescription:
      'Bölgenizdeki yemek eleştirmenlerini ve yorumcuları keşfedin. Sizinle aynı lezzet tutkusunu paylaşan yemek tutkunlarıyla tanışın ve yeni yemek deneyimleri keşfedin.',
    seoKeywords:
      'yemek eleştirmenleri, yemek yorumcuları, lezzet uzmanları, yemek tutkunları, lezzet severler',
    stats: {
      followers: 'Takipçiler',
      following: 'Takip Edilenler',
      rating: 'Puan',
      reviews: 'Yorumlar',
    },
  },
  foods: {
    title: 'Yemekler',
    meta: {
      title: 'Yakınınızdaki Yemekleri Keşfedin',
      description:
        'Bölgenizdeki lezzetli yemekleri keşfedin. Yerel restoranların çeşitli yemeklerinin yorumlarını, puanlarını ve fotoğraflarını inceleyin.',
    },
    searchPlaceholder: 'Yemek ara...',
    noResults: 'Yemek bulunamadı',
    sort: {
      nameAsc: 'İsim A-Z',
      nameDesc: 'İsim Z-A',
      ratingDesc: 'En Yüksek Puan',
      ratingAsc: 'En Düşük Puan',
      reviewCountDesc: 'En Çok Yorum',
      reviewCountAsc: 'En Az Yorum',
    },
    period: {
      allTime: 'Tüm Zamanlar',
      lastWeek: 'Son Hafta',
      lastMonth: 'Son Ay',
      lastYear: 'Son Yıl',
    },
  },
  feed: {
    title: 'Kişisel Yemek Yolculuğun',
    description:
      'Favori yemeklerini, mekanlarını ve yemek tutkunlarını takip ederek mükemmel yemek akışını oluştur. Kişiselleştirilmiş öneriler al ve harika bir yemeği asla kaçırma.',
    discover: 'Keşfetmeye Başla',
    personalizedTitle: 'Yemek Akışın',
    allReviewsTitle: 'En Yeni Yemek Hikayeleri',
    personalizedDescription:
      'Takip ettiğin yemekler, mekanlar ve yemek tutkunlarından değerlendirmeleri gör.',
    joinCommunityDescription:
      'İlgi alanlarına göre kişiselleştirilmiş bir akış için topluluğumuza katıl.',
    noRelatedReviews:
      'Henüz ilgi alanlarına uygun değerlendirmelerimiz yok. Hadi bazı küresel hikayelere göz atalım!',
    showGlobalFeed: 'Küresel Akışı Göster',
    myFeed: 'Akışım',
    globalFeed: 'Küresel Akış',
    globalDescription:
      'Dünyanın dört bir yanından en yeni yemek hikayelerini keşfet.',
    noGlobalReviews:
      'Şu anda küresel değerlendirme bulunmuyor. Yakında tekrar kontrol et!',
    meta: {
      title: 'Yemek Akışı - Kişiselleştirilmiş Yemek Yolculuğun',
      description:
        'Favori yemeklerin, mekanların ve yemek tutkunlarından en yeni yemek değerlendirmelerini ve hikayelerini keşfet. Damak zevkine göre kişiselleştirilmiş öneriler al.',
      keywords:
        'yemek akışı, yemek değerlendirmeleri, kişiselleştirilmiş öneriler, yemek hikayeleri, yemek topluluğu',
    },
    followFoods: {
      title: 'Yemekleri Takip Et',
      description: 'Favori yemeklerini takip et ve yeni çeşitlerini keşfet.',
    },
    followPlaces: {
      title: 'Mekanları Takip Et',
      description:
        'Favori mekanlarından gelen en yeni değerlendirmelerden haberdar ol.',
    },
    followGourmets: {
      title: 'Yemek Tutkunlarını Takip Et',
      description:
        'Senin damak zevkini paylaşan yemek severlerle bağlantı kur ve onların önerilerini keşfet.',
    },
  },
  navigation: {
    home: 'Ana Sayfa',
    discover: 'Keşfet',
    community: 'Topluluk',
    support: 'Destek',
    myProfile: 'Profilim',
    myFeed: 'Akışım',
    gourmets: 'Gurmeler',
    placesNearMe: 'Yakınımdaki Mekanlar',
    foodsNearMe: 'Yakınımdaki Yemekler',
    popularPlacesMonth: 'Ayın En İyi Mekanları',
    mostReviewedPlacesMonth: 'Ayın En Çok Yorumlanan Mekanları',
    popularGourmetsMonth: 'Ayın Popüler Gurmeleri',
    popularFoodsMonth: 'Ayın Popüler Yemekleri',
    popular: 'Popüler',
    contact: 'İletişim',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Koşulları',
  },
  error: {
    pageNotFound: 'Sayfa Bulunamadı',
    pageNotFoundDescription:
      'Aradığınız sayfa kaldırılmış, adı değiştirilmiş veya geçici olarak kullanılamıyor olabilir.',
    needHelp: 'Yardıma mı İhtiyacınız Var?',
    contactUs:
      'Destek ekibimizle iletişime geçin, aradığınızı bulmanıza yardımcı olalım.',
  },
  contact: {
    title: 'Bize Ulaşın',
    name: 'Adınız',
    email: 'E-posta Adresiniz',
    message: 'Mesajınız',
    send: 'Mesaj Gönder',
    nameRequired: 'Lütfen adınızı girin',
    emailRequired: 'Lütfen e-posta adresinizi girin',
    emailInvalid: 'Lütfen geçerli bir e-posta adresi girin',
    messageRequired: 'Lütfen mesajınızı girin',
    pageTitle: 'İletişime Geçin',
    pageDescription:
      'Sorularınız veya yardıma mı ihtiyacınız var? Buradayız! Aşağıdaki formu doldurun veya bize doğrudan e-posta gönderin.',
  },
  app: {
    actions: 'Uygulama İşlemleri',
  },
  download: {
    ios_app: 'iOS Uygulamasını İndir',
    android_app: 'Android Uygulamasını İndir',
  },
  languages: {
    en: 'İngilizce',
    nl: 'Hollandaca',
    tr: 'Türkçe',
    de: 'Almanca',
    fr: 'Fransızca',
    es: 'İspanyolca',
    it: 'İtalyanca',
    pt: 'Portekizce',
    select: 'Dil seçin',
  },
  endOfScroll: {
    placesNearMe: 'Yakınımdaki Mekanlar',
    placesNearMeSubtitle: 'Yakındaki restoran ve yemek yerlerini bul',
    globalFeed: 'Genel Akış',
    globalFeedSubtitle: 'Başkalarının neler beğendiğini gör',
    findPeople: 'Yemek Severler Bul',
    findPeopleSubtitle: 'Diğer yemek tutkunlarıyla bağlantı kur',
    foodsNearMe: 'Yakınımdaki Yemekler',
    foodsNearMeSubtitle: 'Bölgendeki popüler yemekleri keşfet',
  },
  'media': 'Medya',
  'location': 'Mekan',
  // New review modal step explanations
  'review-modal-media-explanation': 'Yemeğinizi göstermek için fotoğraf çekin veya albümünüzden fotoğraflar seçin!',
  'review-modal-rating-explanation': 'Tadı nasıldı? Dürüst yorumunuzu yazın.',
  'review-modal-location-explanation': 'Bu yemeği nerede yediniz?',
  // Draft management
  'draft-cleared': 'Taslak başarıyla silindi!',
  'draft-save-error': 'Ups! Taslağınız kaydedilemedi',
  'clear-draft': 'Taslağı sil',
  comments: {
    title: 'Yorumlar',
    subtitle: 'Sohbete katıl',
    writeComment: 'Yorum yaz...',
    submit: 'Gönder',
    delete: 'Sil',
    noComments: 'Henüz yorum yok. İlk yorum yapan sen ol!',
    loginToComment: 'Yorum yapmak için lütfen giriş yapın',
    loadMore: 'Daha fazla yükle',
    commentAdded: 'Yorum başarıyla eklendi',
    commentError: 'Yorum eklenemedi',
    commentDeleted: 'Yorum silindi',
    deleteError: 'Yorum silinemedi',
    post: 'Gönder',
    placeholder: 'Yorum yaz...',
  },
  mentions: {
    noUsersFound: 'Kullanıcı bulunamadı',
    searchingUsers: 'Kullanıcılar aranıyor...',
  },
};

export default translations;